/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Signin_Resend_InInputs */

const en_signin_resend_in = /** @type {(inputs: Signin_Resend_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend in ${i?.n}s`)
};

const id_signin_resend_in = /** @type {(inputs: Signin_Resend_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kirim ulang dalam ${i?.n} detik`)
};

/**
* | output |
* | --- |
* | "Resend in {n}s" |
*
* @param {Signin_Resend_InInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_resend_in = /** @type {((inputs: Signin_Resend_InInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Resend_InInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_resend_in(inputs)
	return en_signin_resend_in(inputs)
});